var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modules-title",class:{'shadow-style': _vm.currentTitleOption.hasShadow},style:({
    width: ("" + (_vm.$px2rem(((_vm.currentTitleOption.width) + "px")))),
    height: ("" + (_vm.$px2rem(((_vm.currentTitleOption.height) + "px")))),
    background: ("url(" + (_vm.themeConfigureImgUrl(_vm.currentNavObj.titleBg)) + ") no-repeat center"),
    backgroundSize: '100% 100%',
    marginBottom: ("" + (_vm.$px2rem((_vm.marginBottom + "px"))))
  })},[(_vm.currentNavObj.titleLogo)?_c('el-image',{staticClass:"title-logo",attrs:{"src":_vm._f("pageBgConfigure")(_vm.currentNavObj.titleLogo),"alt":"logo"}}):_vm._e(),_c('p',{staticClass:"title-text",style:({
      color: _vm.currentTitleOption.titleColor,
      marginLeft: ("" + (_vm.$px2rem(((_vm.currentNavObj.pageBgId === 1 ? 9 : 0) + "px"))))
    })},[_vm._v(" "+_vm._s(_vm.textLenHandler(_vm.templateNameFilter(_vm.title), _vm.currentTitleOption.maxTextLen))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }